import { Record } from 'immutable';
import { AdjustmentType } from './adjustment-type';

const AdjustmentRecord = Record({
  eventAdjustmentId: null,
  eventId: null,
  adjustmentAmount: 0,
  adjustmentSpendAmount: 0,
  adjustmentCommRate: 0,
  adjustmentType: null,
  description: null,
  createdDate: null,
  eventPartyId: 0
});

export class Adjustment extends AdjustmentRecord {
  eventAdjustmentId: number;
  eventId: number;
  adjustmentAmount: number;
  adjustmentSpendAmount: number;
  adjustmentCommRate: number;
  adjustmentType: AdjustmentType;
  description: string;
  createdDate: Date;
  eventPartyId: number;
}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/models/adjustment.ts